import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.saison-uebersicht-excel';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksSaisonUebersichtExcelEffects {

    SaisonUebersichtExcel$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_SAISON_UEBERSICHT_EXCEL),
        mergeMap((x: ac.GetSaisonUebersichtExcelAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getSaisonUebersichtExcel(x.saisonUebersichtRequest).pipe(
                map((result: any) => {
                    return new ac.GetSaisonUebersichtExcelErfolgreichAction(result, x.saisonUebersichtRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetSaisonUebersichtExcelFehlerAction(error, x.saisonUebersichtRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ControllingQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ControllingQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.ControllingQueryService);
        }
        return this.service;
    }
}
